import { reactive, readonly } from 'vue'

const state = reactive({
  maxHeight: Number(sessionStorage.getItem('maxHeight')) || 0,
  showToast: false
})

function updateMaxHeight(height: number): void {
  state.maxHeight = height
  sessionStorage.setItem('maxHeight', String(height))
}

function setShowToast(val: boolean): void {
  state.showToast = val
}

const Store = {
  state: readonly(state),
  updateMaxHeight,
  setShowToast
}

export default Store